/**
 * Product List Section - Swiper Configuration
 */

document.addEventListener('DOMContentLoaded', function () {
  const swiperElements = document.querySelectorAll('.product-list-swiper');

  swiperElements.forEach((swiperElement) => {
    const slideCount = swiperElement.querySelectorAll('.swiper-slide').length;

    // Clone slides for smooth loop with centeredSlides
    const wrapper = swiperElement.querySelector('.swiper-wrapper');
    const slides = Array.from(wrapper.querySelectorAll('.swiper-slide'));

    // Duplicate slides to ensure smooth looping
    slides.forEach(slide => {
      const clone = slide.cloneNode(true);
      wrapper.appendChild(clone);
    });

    new Swiper(swiperElement, {
      slidesPerView: 'auto',
      spaceBetween: 18,
      centeredSlides: true,
      loop: true,
      loopedSlides: slideCount * 2,
      initialSlide: 1,
      grabCursor: true,
      breakpoints: {
        0: {
          spaceBetween: 12,
        },
        990: {
          spaceBetween: 18,
        },
      },
    });
  });
});
